module.exports = __webpack_public_path__ + "img/green-house.b2da9bda.png";